<!-- eslint-disable standard/no-callback-literal -->
<template>
  <div style="display: flex;">
    <div class="wrap">
      <div class="exercises-wrap">
        <div class="exercises-index-header">
          <div style="display: flex;">
            <div class="exercises-chain" style=" align-self: start;;">
              <img src="../images/kecheng_fanhui.png" @click="backLastPage" style="cursor: pointer;width: 24px;height: 24px;" />
            </div>
            <div class="exercises-info">
                <div class="exercises-title">{{ query.titleName }}</div>
              <!-- <div class="exercises-time">
                <div>发布时间：{{query.release_time}}</div>
                <div>截止时间：{{query.end_time }}</div>
                <div v-if="totalScore && totalScore !== 0">总分：{{totalScore}}</div>
              </div> -->
            </div>
          </div>
          <div v-if="query.type !== 'check'" class="exercises-kshims">考试模式</div>
          <!-- <div class="get-score" v-if="query.type == 'check'">
                <span>得分</span>
                <span class="num">{{ showScore }}</span>
          </div> -->
        </div>
        <div class="exercises-body" v-if="!hasFinished">
          <div class="exercises-left">
            <!-- <div class="exercise-body-top" style="border: none;">
              <div class="feedback" @click="handleOpenFeedback">
                <img src="../img/ico_fankui@2x.png" />
                <span>反馈</span>
              </div>
              <div class="collect" @click="handleCollect">
                <img src="../img/shoucang.png" v-if="!collected" />
                <img src="../img/heart-o@2x.png" v-else />
                <span>收藏</span>
              </div>
            </div> -->
            <div class="exercise-TF" >
              <!-- <p class="rest-time" v-if="testTime===-60">无答题时间限制</p> -->
              <!-- <p class="rest-time" v-else>剩余答题时间 {{formateSeconds(testTime)}}</p> -->
              <!-- <h3 style="padding-top: 21px;">{{questionDetail.name}}</h3> -->
              <div style="display: flex;justify-content: space-between;">
                <div class="exercise_jdpd">
                  <!-- <span>({{curQuestionNum + 1}}/{{questionList.length }})</span> -->
                  <span v-if="questionType === 'TF'">三、判断题</span>
                  <span v-else-if="questionType === 'single'">一、单选题 </span>
                  <span v-else-if="questionType === 'multiple'">二、多选题 </span>
                  <span v-else-if="questionType === 'brief'">四、简答题</span>
                  <span class="exercise_timf">{{`（${curQuestionData.score}分）`}}</span>
                </div>
                <div class="exercise_duosht"><span style="color: #286BFF;">{{curQuestionNum + 1}}</span>/{{questionList.length }}</div>
              </div>
              <div class="exercise_tmbt">
                {{curQuestionNum + 1}}. {{curQuestionData.title}}
              </div>
              <div class="attachment-list" v-if="curQuestionData.file&&curQuestionData.type==4">
                  <div class="attachment-item" v-for="(item,index) in curQuestionData.file" :key="index" @click="handleDownloadFile(item.url)">
                    <img  class="file-icon" :src="require(`../images/homework/${getFileType(item.title)}.png`)"/>
                    <div class="upload-status teacher">
                      <div class="attachment-name">{{ item.title }}</div>
                      <div class="progress" v-if="item.size">
                        <span>{{item.size}}M</span>
                      </div>
                      <div class="progress" v-else-if="item.progress">
                          <span>{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="image-mask" v-else-if="curQuestionData.file&&curQuestionData.type!=4" @mouseover="mouseoverImg" @mouseleave="mouseleaveImg">
                 <el-image style="width: 106px;height: 60px;border-radius: 8px;" fit="cover" v-for="item in curQuestionData.file" :key="item.url" :src="item.url" :preview-src-list="[item.url]"></el-image>
                 <img v-if="isShowImg" class="imgSty" src="../images/magnify.png" alt="">
                </div>
              <!-- 判断题 -->
              <div class="TF-selection TFquestion" v-if="questionType === 'TF'">
                <div style="height: 18px;"></div>
                <div v-for="(item,index) of TFOption" :key="index">
                  <div v-if="query.type != 'check'" class="selection_duanx">
                    <el-radio v-model="radio" :label="item.key" border>
                      <template>
                      <span class="selection-content" style="transform:translateY(-5px)">{{item.value}}</span>
                    </template>
                    </el-radio>
                  </div>
                  <div class="cnmd" v-if="Boolean(curQuestionData.answer && query.type == 'check') && curQuestionData.answer != curQuestionData.user_answer">
                    <div
                      class="selection_duanx"
                      :class="radio == item.key ? 'selection_duanxpdy':'selection_duanxpde'"
                    >
                      <el-radio v-model="radio" :disabled="Boolean(curQuestionData.answer && query.type == 'check')" :label="item.key" border>
                        <template>
                        <span class="selection-content" style="transform:translateY(-5px)">{{item.value}}</span>
                      </template>
                      </el-radio>
                    </div>
                  </div>
                  <div class="cnmd1" v-if="Boolean(curQuestionData.answer && query.type == 'check') && curQuestionData.answer == curQuestionData.user_answer">
                    <div class="selection_duanx" :class="radio != item.key ? 'selection_duanxpdy':'selection_duanxpde'">
                      <el-radio v-model="radio" :disabled="Boolean(curQuestionData.answer && query.type == 'check')" :label="item.key" border>
                        <template>
                        <span class="selection-content" style="transform:translateY(-5px)">{{item.value}}</span>
                      </template>
                      </el-radio>
                    </div>
                  </div>
                </div>
                <!-- <el-radio style="margin-bottom:20px" v-model="radio" :label="item.key" v-for="(item,index) of TFOption" :key="index"
                :class="formatOptionStyle(item.key)"
                :disabled="Boolean(curQuestionData.answer && query.type == 'check')">
                  <template>
                    <span class="selection-content" style="transform:translateY(-5px)">{{item.value}}</span>
                  </template>
                </el-radio> -->
              </div>
              <!-- 单选题 -->
              <div class="TF-selection" style="max-height: 250px; min-height: 140px; overflow-y: auto;" v-else-if="questionType === 'single'">
                <div style="height: 8px;"></div>
                <div v-for="(item, index) of curQuestionData.option" :key="index">
                  <div v-if="Boolean(curQuestionData.answer && query.type == 'check')"
                  class="selection_danxt"
                  :class="{
                      selection_danxtsan: curQuestionData.answer == item.key,
                      selection_danxter: singleSelectRadio == item.key && curQuestionData.user_answer !==  curQuestionData.answer,
                    }"
                  >
                    <span class="selection-item">{{item.key}}.</span>
                    <span class="selection-content">{{item.value}}</span>
                  </div>
                  <!-- <div v-else-if="Boolean(curQuestionData.answer && query.type == 'check') && correct" :class="singleSelectRadio == item.key?'selection_danxtsan':'selection_danxt'">
                    <span class="selection-item">{{item.key}}.</span>
                    <span class="selection-content">{{item.value}}</span>
                  </div> -->
                  <div v-else :class="singleSelectRadio == item.key?'selection_danxtyi':'selection_danxt'" @click="Danxuanti(item.key)">
                    <span class="selection-item">{{item.key}}.</span>
                    <span class="selection-content">{{item.value}}</span>
                  </div>

                  <div class="image-mask" v-if="item.file && item.file.length">
                      <el-image style="width: 106px;height: 60px;border-radius: 8px;" fit="cover" v-for="(items,index) in item.file" :key="index" :src="items.url"  :preview-src-list="[items.url]" @mouseover="mouseoverImgs(item)" @mouseleave="mouseleaveImgs()"></el-image>
                      <img v-show="showOptionId==item.key"  class="imgSty" src="../images/magnify.png" alt="">
                  </div>
                </div>
                <!-- <el-radio-group
                v-model="singleSelectRadio" :disabled="Boolean(curQuestionData.answer && query.type == 'check')">
                <div class="signal-choose" v-for="item of curQuestionData.option" :key="item.key">
                  <el-radio
                  :label="item.key"
                  :class="formatOptionStyle(item.key)"
                  >
                    <template>
                      <span class="selection-item">{{item.key}}</span>
                      <span class="selection-content">{{item.value}}</span>
                    </template>
                  </el-radio>
                   <div class="image-mask" v-if="item.file && item.file.length">
                       <el-image style="width:180px;height:100px" v-for="(items,index) in item.file" :key="index" :src="items.url"  :preview-src-list="[items.url]" @mouseover="mouseoverImgs(item)" @mouseleave="mouseleaveImgs()"></el-image>
                       <img v-show="showOptionId==item.key"  class="imgSty" src="../images/magnify.png" alt="">
                    </div>
                </div>
                </el-radio-group> -->
              </div>
              <!-- 多选题 -->
              <div class="TF-selection" v-else-if="questionType === 'multiple'">
                <div style="height: 18px;"></div>
                <div v-for="(item, index) of curQuestionData.option" :key="index">
                  <div class="selection_duanx"
                  :class="{
                    selection_duanx: multipleList.includes(item.key),
                    selection_duanxyi: successAnswer(item.key) && query.type == 'check',
                    selection_duanxer: multipleList.includes(item.key) && wrongAnswer(item.key) && query.type == 'check',
                  }"
                  >
                    <el-checkbox v-model="multipleList" :disabled="Boolean(query.type == 'check')" :label="item.key" border>
                      <template>
                        <span class="selection-item" style="margin-right: 8px;">{{item.key}}.</span>
                        <span class="selection-content">{{item.value}}</span>
                      </template>
                    </el-checkbox>
                  </div>
                  <div class="image-mask" v-if="item.file && item.file.length">
                     <el-image style="width:180px;height:100px" fit="cover" v-for="(items,index) in item.file" :key="index" :src="items.url"  :preview-src-list="[items.url]" @mouseover="mouseoverImgs(item)" @mouseleave="mouseleaveImgs()"></el-image>
                     <img v-show="showOptionId==item.key"  class="imgSty" src="../images/magnify.png" alt="">
                  </div>
                </div>
                <!-- <el-checkbox-group v-model="multipleList" :disabled="Boolean(curQuestionData.answer && query.type == 'check')">
                  <div class="signal-choose" v-for="item of curQuestionData.option" :key="item.key">
                  <el-checkbox
                  :label="item.key"
                  :class="formatOptionStyle(item.key)"
                  >
                    <template>
                      <span class="selection-item">{{item.key}}</span>
                      <span class="selection-content">{{item.value}}</span>
                    </template>
                  </el-checkbox>
                    <div class="image-mask" v-if="item.file && item.file.length">
                       <el-image style="width:180px;height:100px" v-for="(items,index) in item.file" :key="index" :src="items.url"  :preview-src-list="[items.url]" @mouseover="mouseoverImgs(item)" @mouseleave="mouseleaveImgs()"></el-image>
                       <img v-show="showOptionId==item.key"  class="imgSty" src="../images/magnify.png" alt="">
                    </div>
                  </div>
                  
                </el-checkbox-group> -->
              </div>
              <!-- 简答题 -->
              <div class="TF-selection" v-else-if="questionType === 'brief'">
                <div class="brief-input-box">
                  <el-input   maxlength="1000"  type="textarea" placeholder="请输入简答题答案" v-model="briefAnswer" :disabled="Boolean(query.type == 'check')"></el-input>
                  <!-- <span class="answer-text">回答</span> -->
                </div>
                <div class="attachment-list">
                  <div class="attachment-item" v-for="(item,index) of attachmentList" :key="index">
                    <img class="file-icon" :src="require(`../images/homework/${getFileType(item.title)}.png`)"/>
                    <div class="upload-status" style="display: flex;flex: 1;justify-content: space-between;align-items: center;margin-right: 10px;">
                      <div class="attachment-name">{{ item.title }}</div>
                      <div class="progress" v-if="!item.done && !item.err && item.progress">
                        <span>{{(item.progress.loaded/(1024*1024)).toFixed(2)}}M/{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
                        <el-progress
                        :percentage="item.progress.percent*100"
                        :show-text="false"
                        define-back-color="rgb(255,255,255)"
                        color="#10A675"
                        style="width:155px; margin:0 6px"></el-progress>
                        <span>{{(item.progress.speed/(1024*1024)).toFixed(2)}}m/s</span>
                      </div>
                      <div class="progress" v-else-if="item.done && !item.err && item.progress">
                        <span style="margin-left: 4px;">{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
                      </div>
                      <div class="progress" v-else-if="item.size">
                        <span style="margin-left: 4px;">{{item.size}}M</span>
                      </div>
                      <div class="progress" v-else-if="item.err">
                        <span style="color:#F56C6C">上传失败，请删除重新上传</span>
                      </div>
                    </div>
                    <img class="close-icon" src="../images/ico_guanbi@2x.png" v-if="!Boolean(query.type == 'check')" @click="deleteAttachment(index)" />
                  </div>
                </div>
                <div class="add-attachment" @click="chooseFile" v-if="query.type == 'do' || query.type == 'edit' || query.type == 'doPractice'">
                  <img src="../images/zyfj_tjad.png" />
                  <span>添加附件</span>
                  <input
                  type="file"
                  style="display: none"
                  ref="updateFile"
                  @change="afterRead($event)" />
                </div>
                <!-- <p v-if="curQuestionData.type == 4 && this.query.status == 2" style="font-weight: 600;font-size: 18px;color: #1872ed;">本题得分:{{curQuestionData.user_score}}分</p> -->
              </div>
            </div>
          </div>
          <!-- <div class="exercises-right">
            <h4>答题卡</h4>
            <ul class="exercises-card">
              <li class="exercises-card-item" v-for=" (item,index) of questionCard" :key="item.number"
                :class="item.un==0?'has-done':''" :style="{border:(curQuestionNum==index?'1px solid #0BB65D':'')}"
                @click="changeQuestionOnCard(item.number,index)">{{index+1}}</li>
            </ul>
            <button class="submit-btn" @click="handleSumitPaper">提交试卷</button>
          </div> -->
          <div class="submit-layout" v-if="showSubmitPaper">
            <img src="@/views/images/ico_wancheng@2x.png" />
            <div class="title">恭喜您完成本次作业</div>
            <div class="sub-title">本次部分得分</div>
            <div class="score">
              {{ getScore }}<span>分</span>
            </div>
            <div v-if="query.type !== 'doPractice'" class="tips">简答题分数待老师批阅后可查看</div>
            <div class="feedback-btn">
              <button @click="comfirmBack">返回主页</button>
            </div>
            <!-- <img class="feedback-close" @click="handleCloseSubmitPaper" src="../img/ico_guanbi2@2x.png" /> -->
          </div>
          <div class="mask" v-if="showSubmitPaper" ></div>
        </div>
      </div>
      <div class="switch-question">
              <div class="switch-prev-question" @click="toPrevQuestion" v-if="!isFirst">
                <img src="../images/dati_syt.png" alt="" />
                <!-- <span>上一题</span> -->
              </div>
              <!-- <div class="submit-question">
                <div style="background: none;">
                  <span>{{curQuestionNum + 1}}</span>
                  <span style="color: #202020;">/{{curQuestionData.all_num}}</span>
                </div>
              </div> -->
              <div v-if="this.query.type !== 'doPractice'" :class="isFirst && questionList.length > 1? 'zuoduiqies':''">
                <div  class="switch-prev-questionyi" @click="toPrevQuestionbc" v-if="query.flag == 1"> 
                <!-- <img src="../img/ico_gengduo@2x (3).png" alt="" /> -->
                  <span>保存草稿</span>
                </div>
                <div class="switch-prev-questionyi" @click="toPrevQuestionbc" v-if="query.flag == 2"> 
                  <span>保存草稿</span>
                </div>
                <!-- <div class="switch-prev-questioner switch-prev-questionsan" @click="toPrevQuestionbc" v-if="query.chase === 'chase'"> 
                  <span>答题</span>
                </div> -->
              </div>
              <div v-else :class="isFirst? 'zuoduiqies':''"></div>
              <div class="switch-next-question" @click="toNextQuestion" v-if="!(isEnd && query.type == 'check') && !isEnd">
                <!-- <span>{{ isEnd?'提交':'下一题' }}</span> -->
                <img src="../images/dati_xyt.png" alt="" />
              </div>
              <div class="switch-next-question-tj" @click="toNextQuestion" v-if="!(isEnd && query.type == 'check') && isEnd">
                <!-- <span>{{ isEnd?'提交':'下一题' }}</span> -->
                提交作业
              </div>
      </div>
      <div class="exercises_answer" v-if="query.type == 'check'">
          <div v-if="curQuestionData.type != 3" class="exercises_daanhz">
            <div class="exercises_zqdat" style="display: flex;">
              <img src="../images/dtzqtdt.png" alt="">
              <div v-if="curQuestionData.type != 4" style="margin-left: 8px;">正确答案：<span style="color: #286BFF;">{{ grtSortData(curQuestionData.answer) }}</span></div>
              <div v-else style="margin-left: 8px;">
                本题得分： {{ !query.isHistory ? (questionScore == 0 || questionScore > 0 ? questionScore : '暂无') : '暂无成绩' }}
              </div>
            </div>
            <div v-if="curQuestionData.type != 4" class="exercises_zqdat">
              <div v-if="correct">你的答案：<span style="color: #10B881;">{{ grtSortData(curQuestionData.user_answer) }}</span></div>
              <div v-else>你的答案：<span style="color: #FF8982;">{{ grtSortData(curQuestionData.user_answer) }}</span></div>
            </div>
          </div>
          <div v-else class="exercises_daanhz">
            <div class="exercises_zqdat" style="display: flex;">
              <img src="../images/dtzqtdt.png" alt="">
              <div style="margin-left: 8px;">正确答案：<span style="color: #286BFF;">{{curQuestionData.answer == 1?'正确':'错误'}}</span></div>
            </div>
            <div class="exercises_zqdat">
              <div v-if="correct">你的答案：<span style="color: #10B881;">正确</span></div>
              <div v-else>你的答案：<span style="color: #FF8982;">错误</span></div>
            </div>
          </div>
          <div class="exercises_tmjx">
            <div class="exercises_tmjxbt">题目解析</div>
            <div class="exercises_tmjxnr">
              {{curQuestionData.analysis?curQuestionData.analysis:'暂无解析'}}
            </div>
          </div>
        </div>
    </div>
    <div class="wraper">
      <div v-if="query.type === 'check' && query.status == 2">
        <div class="wraper_zwbxt"></div>
        <div class="wraper_ydwckfhz">
          <div class="wraper_lgfshz">
            <div>
              <div class="wraper_bczypf">本次作业评分</div>
              <div class="wraper_zongfenib">总分：{{Scoretm}}</div>
            </div>
            <div class="wraper_bsfzd">{{ showScore }}<span class="wraper_bsneidf">分</span></div>
          </div>
          <div class="wraper_gkxx"></div>
          <div class="comment" v-if="query.type === 'check' && query.status == 2">
            <div>
              <div style="display: flex;">
                <div class="comment_jspuqz"></div>
                <div class="commemt_jspy">教师评语：</div>
              </div>
              <div class="commemt_jspywz">{{ questionComment || '暂无评语' }}</div>
            </div>
            <div class="attachment-list" v-if="commentFile && commentFile.length">
                    <div class="attachment-itemyi" v-for="(item,index) in commentFile" :key="index" @click="handleDownloadFile(item.url)">
                      <img class="file-icon" src="../images/fujiantuq.png" />
                      <div class="upload-status teacher">
                        <div class="attachment-name">{{ item.title }}</div>
                        <div class="progress" v-if="item.size">
                          <span>{{item.size}}M</span>
                        </div>
                        <div class="progress" v-else-if="item.progress">
                            <span>{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
                        </div>
                      </div>
                    </div>
                  </div>
          </div>
        </div>
      </div>
      <div class="wraper_hz">
        <div style="display: flex;justify-content: space-between;">
          <div class="wraper_dtk">答题卡<span>（<span style="color: rgb(40, 107, 255);">{{curQuestionNum + 1}}</span>/{{questionList.length }}）</span></div>
          <div v-if="query.type !== 'check'" class="wraper_zongf">总分：{{Scoretm}}</div>
        </div>
        <div v-if="query.type !== 'check'" class="wraper_jzsj">截至时间：{{query.end_time}}</div>
        <div v-else class="wraper_jzsj">完成时间：{{query.end_time}}</div>
      </div>
      <div v-if="query.type !== 'check'" class="wraper_dttshz">
        <div class="wraper_datixs">
          <div class="wraper_yddqwdjd"></div>
          <span>已答</span>
        </div>
        <div class="wraper_datixs">
          <div class="wraper_yddqwdjd wraper_yddqwdjdyi"></div>
          <span>当前</span>
        </div>
        <div class="wraper_datixs">
          <div class="wraper_yddqwdjd wraper_yddqwdjder"></div>
          <span>未答</span>
        </div>
        <div class="wraper_datixs">
          <img style="margin-left: 16px;margin-right: 2.8px;" src="../images/weida_jdt.png" alt="">
          <span>简答题</span>
        </div>
      </div>
      <div v-else class="wraper_dttshz">
        <div class="wraper_datixs">
          <div class="wraper_yddqwdjdzq"></div>
          <span>正确</span>
        </div>
        <div class="wraper_datixs">
          <div class="wraper_yddqwdjd wraper_yddqwdjdyicw"></div>
          <span>错误</span>
        </div>
        <div class="wraper_datixs">
          <img style="margin-left: 16px;margin-right: 2.8px;" src="../images/weida_jdt.png" alt="">
          <span>简答题</span>
        </div>
      </div>
      <div :class="query.type !== 'check'?'wraper_dtktm':'wraper_dtktmyi'">
        <div v-for="(item, index) in questionList" :key="index">
            <div v-if="query.type !== 'check'" :class="calculateMultiplesOfSix(index + 1)?'wraper_dtktmcz':'wraper_dtktmczer'" @click="condeDatk(item, index)">
              <div v-if="curQuestionNum != index && item.type !== 4" :class="item.user_answer && item.user_answer != ''?'wraper_dtktmyd':''">
                <!-- 已答 -->
                {{index + 1}}
              </div>
              <div v-if="curQuestionNum == index && item.type !== 4" :class="curQuestionNum == index?'wraper_dtktmdq':''">
                <!-- 当前 -->
                {{index + 1}}
              </div>
              <div class="wraper_dtktmjd" v-if="item.type === 4 && !item.user_answer && curQuestionNum !== index">
                <!-- 简答题 -->
                <div>{{index + 1}}</div>
                <img src="../images/jiandat_ys.png" alt="">
              </div>
              <div class="wraper_dtktmjd" style="background: #286bff;color: #fff;" v-if="item.type === 4 && item.user_answer && item.user_answer != '' && curQuestionNum !== index">
                <!-- 简答题已答 -->
                <div>{{index + 1}}</div>
                <img src="../images/jiandat_ys.png" alt="">
              </div>
              <div class="wraper_dtktmjd" style="background: #d4e1ff;color: #286BFF;" v-if="item.type === 4 && curQuestionNum == index">
                <!-- 简答题当前 -->
                <div>{{index + 1}}</div>
                <img src="../images/jiandat_ys.png" alt="">
              </div>
            </div>  
            <div v-else :class="calculateMultiplesOfSix(index + 1)?'wraper_dtktmcz':'wraper_dtktmczer'" @click="condeDatk(item, index)">
              <div v-if="curQuestionNum != index && item.type !== 4" 
              :class="item.user_answer 
              && item.user_answer != '' 
              && item.answer == item.user_answer?'wraper_dtktmydyi':'wraper_dtktmyder'">
                <!-- 已答 -->
                {{index + 1}}
              </div>
              <div v-if="curQuestionNum == index && item.type !== 4" :class="curQuestionNum == index?'wraper_dtktmdq':''">
                <!-- 当前 -->
                {{index + 1}}
              </div>
              <div class="wraper_dtktmjd" v-if="item.type === 4 && curQuestionNum !== index">
                <!-- 简答题 -->
                <div>{{index + 1}}</div>
                <img src="../images/jiandat_ys.png" alt="">
              </div>
              <div class="wraper_dtktmjd" style="background: #d4e1ff;color: #286BFF;" v-if="item.type === 4 && curQuestionNum == index">
                <!-- 简答题当前 -->
                <div>{{index + 1}}</div>
                <img src="../images/jiandat_ys.png" alt="">
              </div>
            </div>         
        </div>
      </div>
    </div>
    <div class="tankor_tk">
      <el-dialog :visible.sync="dialogVisibleck" :show-close="false" width="464px" style="margin-top: 100px;">
        <div class="tankor_tishi">
          <img class="tankor_tst" src="../images/tankor_tstu.png" alt="">
          <span class="tankor_tswz">提示</span>
        </div>
        <div class="tankor_tsyhwz">{{ tipMessage }}</div>
        <div class="tankor_an">
          <div class="tankor_qx" style="margin-right: 8px;" @click="dialogVisibleck = false">取消</div>
          <div class="tankor_qx" style="background: #286bff;color: #ffffff;" @click="comfirmBack()">确定</div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisibleckSubmit" :show-close="false" width="464px" style="margin-top: 100px;">
        <div class="tankor_tishi">
          <img class="tankor_tst" src="../images/tankor_tstu.png" alt="">
          <span class="tankor_tswz">提示</span>
        </div>
        <div class="tankor_tsyhwz">{{ tipMessage }}</div>
        <div class="tankor_an" :class="tipResult?'tankor_an':'tankor_an1'">
          <div v-if="tipResult" class="tankor_qx" style="margin-right: 8px;" @click="dialogVisibleckSubmit = false">取消</div>
          <div class="tankor_qx" style="background: #286bff;color: #ffffff;" @click="sumbitAnswerRequest()">确定</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import COS from 'cos-js-sdk-v5'
// import { getOnlineApi } from '@/utils/useProxyApi'
import { FileUploadType } from '@/utils/constant'
import { cosUpload } from '@/utils/cosUpload'
import { getFileType } from '@/utils/index.js'

export default {
  data () {
      return {
        skeletonLoading: false,
        radio: '',
        singleSelectRadio: '',
        questionType: 'TF',
        multipleList: [],
        briefAnswer: '',
        showAnswer: false,
        collected: true,
        feedbackContent: '',
        feedbackLink: '',
        showFeedback: false,
        showDialogue: false,
        isWrongQuestion: false,
        isLogin: false,
        showSubmitPaper: false,
        circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        menuList: [{ id: 1, name: '学习中心' }, { id: 2, name: '分销赚钱' }, { id: 3, name: '我的订单' }, { id: 4, name: '账户中心' }, { id: 5, name: '退出登陆' }],
        userInfo: {},
        navLinkList: [],
        searchKey: '',
        partFiveData: {},
        webContactList: [],
        feedbackList: [{ id: 1, name: '题目错误' }, { id: 2, name: '答案错误' }, { id: 3, name: '解析错误' }, { id: 4, name: '其他' }],
        option: {
          num: '',
          ueid: '',
          cid: ''
        },
        TFOption:[{key:'1',value:'正确'},{key:'2',value:'错误'}],
        questionCard: [],
        questionList:[],
        curQuestionData:{},
        curQuestionNum: 0,
        curQuestionShowNum: 1,
        questionDetail: {},
        hasDone: false,
        userAnswer: [],
        recordTimer: null,
        curFeedbackType: [],
        testTime: '',
        testTimer: null,
        hasFinished: false,
        testScore: 0,
        attachmentList:[],
        commentFile:[],
        questionComment:'',
        uploading:false,
        getScore:0,
        showScore:0,
        totalScore:'',
        isShowImg:false,
        showOptionId:'',
        Scoretm: 0,
        dialogVisibleck: false,
        dialogVisibleckSubmit: false,
        tipMessage: '', // 提示信息
        tipResult: true, // 提示结果类型
      }
    },
    props:{
      query:{
      type:Object,
      default(){
        return{}
      }
    }
    },
    created () {
    if(this.query.type == 'do' || this.query.type == 'doPractice'){
      this.getQuestionContent()
    }
    if(this.query.type == 'check' || this.query.type == 'edit'){
      this.getDoneQuestionContent()
    }
    
          // 初始化实例
    console.log('query',this.query)
    // this.cos = new COS({
    //   // getAuthorization 必选参数
    //   getAuthorization: function (options, callback) {
    //     // 异步获取临时密钥
    //     // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
    //     // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
    //     // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
    //     // const baseUrl = process.env.VUE_APP_API_ONLINE_SCHOOL
    //     const baseUrl = getOnlineApi()
    //     var url = `${baseUrl}/common/index/getCosSign` // url替换成您自己的后端服务
    //     var xhr = new XMLHttpRequest()
    //     xhr.open('GET', url, true)
    //     xhr.onload = function (e) {
    //       try {
    //         var data = JSON.parse(e.target.responseText)
    //         var credentials = data.data.credentials
    //       } catch (e) {
    //         console.log(e);
    //       }
    //       if (!data || !credentials) {
    //         return console.error(
    //           'credentials invalid:\n' + JSON.stringify(data, null, 2)
    //         )
    //       }
    //       callback({
    //         TmpSecretId: credentials.tmpSecretId,
    //         TmpSecretKey: credentials.tmpSecretKey,
    //         SecurityToken: credentials.sessionToken,
    //         // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
    //         StartTime: data.data.startTime, // 时间戳，单位秒，如：1580000000
    //         ExpiredTime: data.data.expiredTime, // 时间戳，单位秒，如：1580000000
    //       })
    //     }
    //     xhr.send()
    //   },
    // })
    },
    computed: {
      isEnd () {
        return this.curQuestionNum+1 >= this.questionList.length
      },
      isFirst () {
        return this.curQuestionNum <= 0
      },
      correct(){
        if(this.curQuestionData.type && this.curQuestionData.type !== 4 && this.curQuestionData.user_answer && (this.curQuestionData.answer)){
          return [...this.curQuestionData.user_answer].sort().join('') == [...this.curQuestionData.answer].sort().join('')
        }
        return false
      },
      wrongAnswer() {
        return function(key){
          if(!this.curQuestionData.answer) return false
          if(!this.curQuestionData.answer.includes(key)){
            return true
          }
          return false
        }
		  },
      successAnswer() {
        return function(key){
          if(!this.curQuestionData.answer) return false
          if(this.curQuestionData.answer.includes(key)){
            return true
          }
          return false
        }
      },
      questionScore() {
        let score = ''
        if (this.query.type !== 'doPractice') {
          if (this.curQuestionData.user_score == 0 || this.curQuestionData.user_score > 0) {
            if (this.query.type == 'check') {
              score = this.curQuestionData.user_score
            } else {
              score = '暂无'
            }
          } else {
            score = '暂无'
          }
        } else {
          score = '暂无成绩'
        }
        return score
      }
    },
   watch:{
    curQuestionNum(val){
      this.radio = ''
      this.singleSelectRadio = ''
      this.multipleList = []
      this.briefAnswer = ''
      this.attachmentList=[]
      this.curQuestionData = this.questionList[val]
      console.log('222', this.questionList)
      switch (this.curQuestionData.type) {
            case 3:
              this.questionType = 'TF'
              if (this.curQuestionData.user_answer) {
                this.radio = this.curQuestionData.user_answer
              }
              break
            case 1:
              this.questionType = 'single'
              if (this.curQuestionData.user_answer) {
                this.singleSelectRadio = this.curQuestionData.user_answer
                console.log(this.singleSelectRadio)
              }
              break
            case 2:
              this.questionType = 'multiple'
              if (this.curQuestionData.user_answer) {
                this.multipleList = this.curQuestionData.user_answer.split('')
                console.log(this.multipleList)
              }
              break
            case 4:
              this.questionType = 'brief'
              if (this.curQuestionData.user_answer || (this.curQuestionData.answer_file && this.curQuestionData.answer_file.length)) {
                this.briefAnswer = this.curQuestionData.user_answer
                this.attachmentList = this.curQuestionData.answer_file || []
              }
              break
      }
    }
   },
   methods: {
    getFileType,
    grtSortData(data) {
      if (data) {
        return data.split('').sort().join('')
      }
      return ''
    },
    shifouxianshi(item, index) {
      // console.log('itemitemitemitem===', item, this.multipleList, this.curQuestionData.answer.split(''))
      const data = this.curQuestionData.answer.split('')
      this.zqtd = false
      this.wdda = false
      data.forEach(Zrde=>{
        if (Zrde == item.key) {
          this.zqtd = true
        }
      })
      this.multipleList.forEach(Zrdr=>{
        if (Zrdr == item.key) {
          this.wdda = true
        }
      })
      console.log('sssss======', this.wdda, this.zqtd)
      if(index == 0) {
        if (this.zqtd && !this.wdda ) {
          return true
        }
      }  else if (index == 1) {
        if (this.zqtd && this.wdda ) {
          return true
        }
      } else if (index == 2) {
        if (!this.zqtd && this.wdda ) {
          return true
        }
      }
      // return true
    },
    condeDatk(item, index) {
      if(this.radio){
        this.questionList.forEach(item=>{
          if(item.id == this.curQuestionData.id){
            item.user_answer = this.radio
          }
        })
      }
      if(this.singleSelectRadio){
        this.questionList.forEach(item=>{
          if(item.id == this.curQuestionData.id){
            item.user_answer = this.singleSelectRadio
          }
        })
      }
      if(this.multipleList.length){
        this.questionList.forEach(item=>{
          if(item.id == this.curQuestionData.id){
            item.user_answer = this.multipleList.join('')
          }
        })
      }
      if(this.briefAnswer){
        this.questionList.forEach(item=>{
          if(item.id == this.curQuestionData.id){
            item.user_answer = this.briefAnswer
          }
        })
      }
      let prevData = this.questionList[this.curQuestionNum]
      if (!prevData.isShow && prevData.user_answer) {
        console.log('变成已答状态')
        prevData.isShowAnswered = true
      }
      if(this.attachmentList.length){
        this.questionList.forEach(item=>{
          if(item.id == this.curQuestionData.id){
            item.answer_file= this.attachmentList.map(item=>{
              if(item.size){
                return {
                title:item.title,
                url:item.url,
                size:item.size
              }
              }
              return {
                title:item.title,
                url:item.url,
                size:(item.progress.total/(1024*1024)).toFixed(2)
              }
            })
          }
        })
      }
      this.$nextTick(() => {
        this.curQuestionNum = index
      })

    },
    calculateMultiplesOfSix(item) {
      // 循环从1到118，检查每个数字是否是6的倍数，并添加到数组中
      if (item % 6 === 0) {
        return true
      }
    },
    Danxuanti (item) {
      if (this.questionType === 'single') {
        this.singleSelectRadio = item
      } else if (this.questionType === 'multiple') {
        console.log('ew15===11111', item, this.multipleList)

      }
      console.log('ew15===', this.questionList)
    },
    mouseoverImgs(item){
      this.showOptionId=item.key
    },
    mouseleaveImgs(){
      this.showOptionId=''
    },
    mouseoverImg(){
      this.isShowImg=true
    },
    mouseleaveImg(){
      this.isShowImg=false
    },
      // 获取当前题目内容请求
      async getQuestionContent () {
        const data = { qt_id: this.query.qt_id }
        const res = await this.$axios.post('/user/index/dotask', data)
        if (res.data.code === 200) {
          this.questionList = res.data.data
          this.questionList.forEach(item=>{
            this.Scoretm += item.score
          })
          console.log('questionList: ', this.questionList)
          this.skeletonLoading = false
          if(this.questionList.length){
            this.curQuestionData = this.questionList[0]
          }
          console.log('curQuestionData: ', this.curQuestionData)
          switch (this.curQuestionData.type) {
            case 3:
              this.questionType = 'TF'
              if (this.curQuestionData.user_answer) {
                this.radio = this.curQuestionData.user_answer
              }
              break
            case 1:
              this.questionType = 'single'
              if (this.curQuestionData.user_answer) {
                this.singleSelectRadio = this.curQuestionData.user_answer
              }
              break
            case 2:
              this.questionType = 'multiple'
              if (this.curQuestionData.user_answer) {
                this.multipleList = this.curQuestionData.user_answer.split('')
              }
              break
            case 4:
              this.questionType = 'brief'
              if (this.curQuestionData.user_answer) {
                this.briefAnswer = this.curQuestionData.user_answer
                this.attachmentList = this.curQuestionData.answer_file || []
              }
              break
      }
        }
      },
            // 获取已做题目内容请求
      async getDoneQuestionContent () {
        const data = { qt_id: this.query.qt_id, section_id:this.query.section_id, chapter_id:this.query.chapter_id, ucqid:this.query.ucqid}
        const res = await this.$axios.post('/user/index/see2', data)
        if (res.data.code === 200 && res.data.data) {
          this.questionList = res.data.data.answer_list.map(item=>{
              item.id = item.qid
              delete item.qid
              if (item.answer_file && item.answer_file.length > 0) {
                 item.answer_file.forEach(item1=>{
                  item1.done = true
                })
              }
              return item
          })
          this.questionList.forEach(item=>{
            this.Scoretm += item.score
          })
          this.showScore = res.data.data.comment.user_score
          this.totalScore = res.data.data.comment.total
          if(this.questionList.length){
            if(this.query.type == 'check' && this.query.status == 2){
              this.curQuestionNum = 0
              this.curQuestionData = this.questionList[this.curQuestionNum]
              console.log('[<-- this.curQuestionData -->]',this.curQuestionData);            
              this.questionComment = res.data.data.comment.comment
              this.commentFile = res.data.data.comment.files
            }
            this.curQuestionData = this.questionList[0]
          }
          switch (this.curQuestionData.type) {
            case 3:
              this.questionType = 'TF'
              if (this.curQuestionData.user_answer) {
                this.radio = this.curQuestionData.user_answer
              }
              break
            case 1:
              this.questionType = 'single'
              if (this.curQuestionData.user_answer) {
                this.singleSelectRadio = this.curQuestionData.user_answer
              }
              break
            case 2:
              this.questionType = 'multiple'
              if (this.curQuestionData.user_answer) {
                this.multipleList = this.curQuestionData.user_answer.split('')
              }
              break
            case 4:
              this.questionType = 'brief'
              this.briefAnswer = this.curQuestionData.user_answer || ""
              this.attachmentList = this.curQuestionData.answer_file || []
              break
           }
          switch (this.curQuestionData.iscoll) {
            case 0:
              this.collected = false
              break
            case 1:
              this.collected = true
          }
          console.log(this.questionList)
        }
      },
      // 在答题卡上切换题目
      async changeQuestionOnCard (num) {
        this.curQuestionNum = num
        this.radio = ''
        this.briefAnswer = ''
        this.singleSelectRadio = ''
        this.multipleList = []
        await this.getQuestionContent(this.curQuestionNum, this.option.uqid)
        this.changeURLParam('num', this.curQuestionNum)
      },
      // 保存草稿
      async toPrevQuestionbc () {
        // 如果当前有附件没有上传成功，则需要等附件上传完才能保存草稿
        if(this.attachmentList.find(item => !item.done)) {
            this.$message.warning('请等待文件上传完成再操作')
            return
        }
        const content = this.questionList.map(item=>{
          if(this.attachmentList instanceof Array && (this.attachmentList.length || this.attachmentList.length === 0)) {
            if(item.id == this.curQuestionData.id) {
              item.answer_file = this.attachmentList.map(item => {
                if(item.size){
                  return {
                    title:item.title,
                    url:item.url,
                    size:item.size,
                    done:item.done
                  }
                } else {
                  return {
                    title:item.title,
                    url:item.url,
                    size:(item.progress.total/(1024*1024)).toFixed(2),
                    done:item.done
                  }
                }
              })
            }
          }
          if(item.type == 4){
            if(this.briefAnswer){
                if(item.id == this.curQuestionData.id){
                  item.user_answer = this.briefAnswer
                }
            }
            // else {
            //   if(item.id == this.curQuestionData.id){
            //       item.user_answer = this.briefAnswer
            //     }
            // }
            if(item.user_answer == null) {
              item.user_answer = ''
            }
            return{
              file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
              qid:item.id,
              title:item.title,
              type:item.type,
              answer:item.user_answer,
              score:0
            }
          }else{
            if(this.radio){
                if(item.id == this.curQuestionData.id){
                  item.user_answer = this.radio
                }
            }
            if(this.singleSelectRadio){
                if(item.id == this.curQuestionData.id){
                  item.user_answer = this.singleSelectRadio
                }
            }
            if(this.multipleList.length){
                if(item.id == this.curQuestionData.id){
                  item.user_answer = this.multipleList.join('')
                }
            }
            if(item.user_answer == null) {
              item.user_answer = ''
            }
            return{
              qid:item.id,
              title:item.title,
              answer:item.user_answer,
              type:item.type,
              file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
              score:  [...item.user_answer].sort().toString() == [...item.answer].sort().toString()?item.score:0
            }
          }
        })
        this.getScore = content.reduce((total,item)=>{return total+item.score},0)
        const data = {
          cq_id: this.query.cq_id,
          content:JSON.stringify(content)
        }
        const res = await this.$axios.post('/user/index/save', data)
        if (res.data.code === 200) {
          // this.showSubmitPaper = true
          this.$message({
              type: 'success',
              message: '保存草稿成功'
          })
          // eslint-disable-next-line vue/no-mutating-props
          this.query.flag = 1
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
      },
      // 提交答案请求
      async sumbitAnswerRequest () {
        if (!this.tipResult) {
          this.dialogVisibleckSubmit = false
          return
        }
        const content = this.questionList.map(item=>{
          console.log(item)
          if(item.type == 4){
            return{
              file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
              qid:item.id,
              title:item.title,
              type:item.type,
              answer:item.user_answer,
              score:0
            }
          }else{
            return{
              qid:item.id,
              title:item.title,
              answer:item.user_answer,
              type:item.type,
              file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
              score:[...item.user_answer].sort().toString() == [...item.answer].sort().toString()?item.score:0,
              isSuccess: [...item.user_answer].sort().toString() == [...item.answer].sort().toString() ? true : false
            }
          }
        })
        this.getScore = content.reduce((total,item)=>{return total+item.score},0)
        let data = {
          cq_id: this.query.cq_id,
          content:JSON.stringify(content),
          mode: 1
        }
        let urlLink = '/user/index/submit'
        if (this.query.isConsolidation) {
          urlLink = '/user/question/historySubmit'
          data = { cq_id: this.query.cq_id, ucq_id: this.query.ucqid, content: JSON.stringify(content),mode: 1 }
        }
        const res = await this.$axios.post(urlLink, data)
        if (res.data.code === 200) {
          this.showSubmitPaper = true
          this.dialogVisibleckSubmit = false
          // this.$emit('changePage',{page:'Provideinstructions',query:this.getScore})
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
      },
      // 下一题
      async toNextQuestion () {
        console.log(this.curQuestionData.id, this.curQuestionData)
        if(this.query.type == 'check'){
          this.curQuestionNum++
          return
        }
        // if(this.uploading){
        //     this.$message.error('请等待文件上传完成再操作')
        //   return
        // }
        if(this.radio){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.radio
            }
          })
        }
        if(this.singleSelectRadio){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.singleSelectRadio
            }
          })
        }
        if(this.multipleList.length){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.multipleList.join('')
            }
          })
        }
        if(this.briefAnswer){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.briefAnswer
            }
          })
        }

        console.log("this.attachmentList",this.attachmentList)
        // 如果当前有附件没有上传成功，则需要等附件上传完才能保存草稿
        if(this.attachmentList.find(item => !item.done)) {
            this.$message.warning('请等待文件上传完成再操作')
            return
        }
        if(this.attachmentList instanceof Array && (this.attachmentList.length || this.attachmentList.length === 0)){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.answer_file= this.attachmentList.map(item=>{
                if(item.size){
                  return {
                  title:item.title,
                  url:item.url,
                  size:item.size,
                  done:item.done
                }
                }
                return {
                  title:item.title,
                  url:item.url,
                  size:(item.progress.total/(1024*1024)).toFixed(2),
                  done:item.done
                }
              })
            }
          })
        }
        if(this.isEnd && this.query.type !== 'doPractice'){
          const endTime = new Date(this.query.end_time).getTime()
          const nowTime = new Date().getTime()
          const tipResult = this.questionList.some(item=> !item.user_answer)
          this.dialogVisibleckSubmit = true
          if(tipResult){
            this.tipMessage = '当前有作业未填写，请填写后提交'
          }else{
            if(nowTime>endTime){
              this.tipMessage="当前已过截止时间，提交后为迟交状态，确定还要提交吗？"
            }else{
              this.tipMessage = "请仔细检查作业，是否确认提交"
            }
          }
          
          this.tipResult = !tipResult
          return
        }
        if (this.isEnd && this.query.type === 'doPractice') {
          const tipResult = this.questionList.some(item=> !item.user_answer)
          if (tipResult) {
            this.tipMessage = '当前有作业未填写，请填写后提交'
          } else {
            this.tipMessage = '请仔细检查作业，是否确认提交'
          }
          this.dialogVisibleckSubmit = true
          this.tipResult = !tipResult
          return
        }
        this.curQuestionNum++
        
        // this.briefAnswer = ''
        // this.singleSelectRadio = ''
        // this.multipleList = []
      },
      // 上一题
      async toPrevQuestion () {
        if(this.query.type == 'check'){
          this.curQuestionNum--
          return
        }
        // if(this.uploading){
        //     this.$message.error('请等待文件上传完成再操作')
        //   return
        // }
        if(this.radio){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.radio
            }
          })
        }
        if(this.singleSelectRadio){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.singleSelectRadio
            }
          })
        }
        if(this.multipleList.length){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.multipleList.join('')
            }
          })
        }
        if(this.briefAnswer){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.briefAnswer
            }
          })
        }
        if(this.attachmentList.length){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.answer_file= this.attachmentList.map(item=>{
                if(item.size){
                  return {
                  title:item.title,
                  url:item.url,
                  size:item.size,
                  done:item.done
                }
                }
                return {
                  title:item.title,
                  url:item.url,
                  size:(item.progress.total/(1024*1024)).toFixed(2),
                  done:item.done
                }
              })
            }
          })
        }
        this.curQuestionNum--
      },
      // 每分钟调用答题时间接口
      recordTimeMin () {
        this.recordTimer = setInterval(() => {
          this.recordTimeRequest()
        }, 60000)
      },
      // 选择反馈类型
      changeFeedbackType (id, name) {
        if (this.curFeedbackType.indexOf(name) !== -1) {
          this.curFeedbackType.splice(this.curFeedbackType.indexOf(name), 1)
        } else {
          this.curFeedbackType = [...this.curFeedbackType, name]
        }
        console.log(this.curFeedbackType)

      },
 

      handleOpenFeedback () {
        this.showFeedback = true
        this.showDialogue = true
        this.handleCloseLogin()
        const body = document.querySelector('body')
        if (this.showFeedback) {
          body.setAttribute('style', 'position:fixed;left: 0px;right: 0px;overflow: hidden;')
        }
      },
      handlePreventScroll () {
        const body = document.querySelector('body')
        if (this.showFeedback || this.showSubmitPaper) {
          body.setAttribute('style', 'position:fixed;left: 0px;right: 0px;overflow: hidden;')
        }
      },
      handleCloseFeedback () {
        this.showFeedback = false
        this.showDialogue = false
        const body = document.querySelector('body')
        body.removeAttribute('style')
      },
      handleSumitPaper () {
        this.showDialogue = true
        this.showSubmitPaper = true
        this.handlePreventScroll()
      },
      handleCloseSubmitPaper () {
        this.showDialogue = false
        this.showSubmitPaper = false
        const body = document.querySelector('body')
        body.removeAttribute('style')
      },
      // 跳转参考链接
      handleToReferPage(link){
        window.open(link,'_blank')
      },
      chooseFile() {
      this.$refs.updateFile.click()
      },
          // 上传头像
    async afterRead(e) {
      // 此时可以自行将文件上传至服务器
      let file = e.target.files[0]
      this.attachmentList.unshift({title:file.name, done:false, err:false})
      this.uploading = true
      try {
        const { url } = await cosUpload(file, false, FileUploadType.HOMEWORK, (process) => {
          this.attachmentList.forEach((item,i)=>{
            if(item.title === file.name){
              this.$set(this.attachmentList[i], 'progress', process)
            }
          })
        })
        this.attachmentList.forEach((item,i)=>{
          if(item.title === file.name){
            this.$set(this.attachmentList[i], 'done', true)
            this.$set(this.attachmentList[i], 'url', url)
          }
        })
      } catch(error) {
        console.log(error)
      } finally {
        this.uploading = false
      }
    },
    backLastPage(){
      console.log(this.query)
      this.dialogVisibleck = true
      if (this.query.flag == 1) {
        this.tipMessage = '退出后可在草稿箱继续完成剩余题目并提交，是否确认退出？'
      } else {
        this.tipMessage = '返回将不会保存填写的内容，确定返回吗?'
        if (this.query.type == 'doPractice') {
          this.tipMessage = '退出本次练习不计算成绩,是否确认退出？'
        }
        if(this.query.type == 'check'){
          this.comfirmBack()
          return
        }
      }
    },
    comfirmBack(){
      delete this.query.cq_id
      this.$emit('changePage',{page:'HomeworkDetail',query:this.query})
    },
    deleteAttachment(index){
      this.uploading =  false
      this.attachmentList.splice(index,1)
    },
    handleDownloadFile(url){
      window.open(url,'_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
body {
    -ms-overflow-style: -ms-autohiding-scrollbar; /* 自动隐藏滚动条 */
}
/* 整个滚动条 */
::-webkit-scrollbar {
  width: 4px;
  height: 12px !important;
}
 
/* 滚动条上的滚动滑块 */
::-webkit-scrollbar-thumb {
    background-color: #e3e8e9; /* 滑块颜色 */
    border-radius: 6px; /* 滑块圆角 */
    // background: #e3e8e9; /* 滑块边框 */
}
.tankor_tk {
  .tankor_an {
    width: 248px;
    height: 30px;
    margin: 0 auto;
    padding-bottom: 24px;
    display: flex;
    .tankor_qx {
      width: 120px;
      height: 30px;
      background: #ebeef4;
      border-radius: 8px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-500;
      font-weight: 500;
      text-align: center;
      color: #202020;
      line-height: 30px;
      cursor: pointer;
    }
    &.tankor_an1 {
      justify-content: center;
    }
  }
  .tankor_tsyhwz {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    color: #202020;
    text-align: center;
    padding-bottom: 16px;
  }
  .tankor_tishi {
    width: 60px;
    margin: 0 auto;
    display: flex;
    padding-top: 25px;
    padding-bottom: 17px;
    .tankor_tswz {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-500;
      color: #202020;
    }
    .tankor_tst {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  ::v-deep .el-dialog{
        border-radius: 16px;
      }
    ::v-deep .el-dialog__header{
        padding: 0px;
        padding-bottom: 0px;
      }
    ::v-deep .el-dialog__body {
      padding: 0;
      // height: 263px;
      background: #ffffff;
      border-radius: 16px;
    }
}
::deep .el-radio__input.is-checked .el-radio__inner::after {
      top: 8px;
      left: 8px;
      width: 4px;
      height: 4px;
      background: #ffffff;
      border: 2px solid #e3e8e9;
      border-radius: 9px;
    }
.wraper_dtktmyder {
  width: 30px;
  height: 30px;
  background: #ff8982;
  border-radius: 20px;
  color: #fff;
}
.wraper_dtktmydyi {
  width: 30px;
  height: 30px;
  background: #10b881;
  border-radius: 20px;
  color: #fff;
}
.wraper_dtktmyd {
  width: 30px;
  height: 30px;
  background: #286bff;
  border-radius: 20px;
  color: #ffffff;
}
.wraper_dtktmjd {
  width: 30px;
  height: 30px;
  background: #ebeef4;
  overflow: hidden;
  border-radius: 20px;
  img {
    // position: absolute;
    width: 31px;
    height: 10px;
    position: relative;
    top: -20px;
    right: 1px;
  }
}
.wraper_dtktmdq {
  width: 30px;
  height: 30px;
  background: #d4e1ff;
  border-radius: 20px;
  color: #286BFF;
}
.wraper {
  width: 300px;
  height: 753px;
  background: #ffffff;
  margin-top: 20px;
  float: left;
  .wraper_ydwckfhz {
    width: 276px;
    max-height: 320px;
    background: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 8px;
    margin: 0 auto;
    margin-top: 20px;
    position: relative;
    .wraper_gkxx {
      width: 100%;
      height: 12px;
      background: url('../images/homework/cut-off-rule.png') no-repeat;
      background-size: contain;
      margin-top: 16px;
    }
    .wraper_lgfshz {
      display: flex;
      justify-content: space-between;
      margin-left: 12px;
      margin-top: 24px;
      .wraper_bsfzd {
        font-size: 40px;
        font-family: DINPro, DINPro-700;
        font-weight: 700;
        color: #286bff;
        margin-right: 12px;
        .wraper_bsneidf {
          font-size: 14px;
          color: #848586;
          font-weight: 400;
          margin-left: 4px;}
      }
      .wraper_zongfenib {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #848586;
        margin-top: 4px;
      }
      .wraper_bczypf {
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-600;
        font-weight: 600;
        color: #202020;
      }
    }
  }
  .wraper_zwbxt {
    width: 300px;
    height: 109px;
    position: absolute;
    background: url(../images/chakandwtmt.png);
    background-size: 100% 100%;
    top: 20px;
  }
  .wraper_dtktmyi {
    display: flex;
    flex-wrap: wrap;
    width: 252px;
    max-height: 375px;
    overflow-y: auto;
    margin: 0 auto;
    .wraper_dtktmcz{
      width: 30px;
      height: 30px;
      border: 1px solid #e3e8e9;
      border-radius: 20px;
      margin-top: 16px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      text-align: center;
      color: #202020;
      line-height: 30px;
      margin-right: 0px;
      cursor: pointer;
    }
    .wraper_dtktmczer{
      width: 30px;
      height: 30px;
      border: 1px solid #e3e8e9;
      border-radius: 20px;
      margin-top: 16px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      text-align: center;
      color: #202020;
      line-height: 30px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .wraper_dtktm {
    display: flex;
    flex-wrap: wrap;
    width: 252px;
    max-height: 647px;
    overflow-y: auto;
    margin: 0 auto;
    .wraper_dtktmcz{
      width: 30px;
      height: 30px;
      border: 1px solid #e3e8e9;
      border-radius: 20px;
      margin-top: 16px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      text-align: center;
      color: #202020;
      line-height: 30px;
      margin-right: 0px;
      cursor: pointer;
    }
    .wraper_dtktmczer{
      width: 30px;
      height: 30px;
      border: 1px solid #e3e8e9;
      border-radius: 20px;
      margin-top: 16px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      text-align: center;
      color: #202020;
      line-height: 30px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .wraper_dttshz {
    width: 252px;
    height: 20px;
    display: flex;
    margin: 0 auto;
    margin-top: 16px ;
    .wraper_datixs {
      display: flex;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #848586;
      align-items: center;
      img {
        width: 16px;
        height: 16px;
        border-radius: 18px;
      }
      .wraper_yddqwdjdzq {
        width: 14px;
        height: 14px;
        background: #10b881;
        border: 0.8px solid #10b881;
        border-radius: 80px;
        margin-right: 2.8px;
        margin-top: 2px;
      }
      .wraper_yddqwdjd {
        width: 14px;
        height: 14px;
        background: #286bff;
        border: 0.8px solid #286bff;
        border-radius: 80px;
        margin-right: 2.8px;
        margin-top: 2px;
      }
      .wraper_yddqwdjdyicw {
        background: #ff8982;
        border: 0.8px solid #ff8982;
        margin-left: 16px;
      }
      .wraper_yddqwdjdyi {
        background: #d4e1ff;
        border: 0.8px solid #d4e1ff;
        margin-left: 16px;
      }
      .wraper_yddqwdjder {
        background: #fff;
        border: 0.8px solid #e3e8e9;
        margin-left: 16px;
      }
    }
  }
  .wraper_hz {
    width: 252px;
    height: 46px;
    margin: 0 auto;
    margin-top: 20px;
    .wraper_jzsj {
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #848586;
      margin-top: 5.5px;
    }
    .wraper_zongf {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-500;
      font-weight: 500;
      color: #848586;
    }
    .wraper_dtk {
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-500;
      font-weight: 500;
      color: #202020;
      span {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-500;
        font-weight: 500;
        color: #848586;
      }
  }
  }
}
.wrap {
  background: #ffffff;
  margin: 20px 20px 20px 20px;
  float: left;
  // padding: 0px 24px;
  width: 560px;
  height: 753px;
  .header{
    padding-bottom: 17px;
    border-bottom: 1px solid #e8eaec;
    .header-top{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      img{
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .header-bottom{
      display: flex;
      font-size: 14px;
      color: #808695;
      margin-left: 30px;
      div{
        margin-right: 30px;
      }
    }
  }
}
.settle-body{
  width: 100%;
  background: #F7F7F7;
  font-size: 14px;
  line-height: 22px;
  color: #202020;
}
.exercises-kshims {
    width: 72px;
    height: 24px;
    background: #eaf1ff;
    border-radius: 8px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    text-align: center;
    color: #286bff;
    line-height: 24px;
    margin-left: 4px;
    margin-top: 20px;
}
.exercises-chase {
  color: #10b881;
  background: #e8f8f3;
  border-radius: 8px;
}
.exercises-index-header{
  display: flex;
  // align-items: center;
  width: 560px;
  height: 60px;
  border-bottom: 1px solid #f0f4f5;
  // justify-content: center;
  img{
    width: 20px;
    height: 20px;
    margin-left: 24px;
    margin-top: 20px;
    // margin-right: auto;
  }
  .get-score{
    align-self: start;
    color: #808695;
    font-size: 14px;
    .num{
      color: #F34718;
      font-size: 26px;
      margin-left: 4px;
      font-weight: 600;
    }
  }
  .exercises-info{
    // margin:0 auto;
    width: 396px !important;
    .exercises-title{
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-500;
      font-weight: 500;
      color: #20242f;
      margin-top: 21px;
      margin-left: 16px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* 设置行数为2 */
      overflow: hidden;
      // line-height: 22px;
      // margin-bottom: 20px;
    }
    .exercises-time{
      display: flex;
      font-size: 14px;
      font-weight: 400;
      color: #808695;
      justify-content: space-between;
      margin-bottom:20px;
    }
  }
}
.comment{
  width: 100%;
  min-height: 148px;
  // background: #eff2f5;
  font-size: 16px;
  // color: #1872ed;
  // box-sizing: border-box;
  margin: 0 auto;
  // padding: 11px 16px;
  margin-top: 16px;
  .commemt_jspy {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-500;
    font-weight: 500;
    color: #202020;
    margin-left: 4px;
  }
  .commemt_jspywz {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    width: 100%;
    padding-right: 12px;
    box-sizing: border-box;
    height: 80px;
    color: #202020;
    overflow-y: auto;
    margin-top: 8px;
    white-space: pre-wrap;
    word-break: break-all;
    word-wrap: break-word;
    text-align: justify;
  }
  .comment_jspuqz {
    width: 3px;
    height: 11px;
    background: #286bff;
    border-radius: 5px;
    margin-top: 4px;
  }
  .attachment-list{
    max-height: 100px;
    overflow-y: auto;
    padding-right: 12px;
    box-sizing: border-box;
    // display: grid;
    // grid-template-columns: 1fr 1fr 1fr;
    margin: 10px 0;
    // gap: 10px;
    display: flex;
    flex-direction: column;
    .attachment-itemyi {
      width: 100%;
      height: 32px;
      background: #f4f6f6;
      border-radius: 8px;
      .upload-status{
        display: flex;
        align-items: center;
        .attachment-name{
          max-width: 152px;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
          font-size: 14px;
          color: #202020;
        }
      }
    }
    .attachment-item{
      width: 276px;
      color: #202020;
      background: #ffffff;
      margin-bottom: 0;
      .upload-status{
        display: flex;
        align-items: center;
        .attachment-name{
          max-width: 177px;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap
        }
      }

    }
   
  }
}
 .image-mask{
      width: 180px;
      height: 66px;
      position: relative;
      margin: 10px 0px;
    }
    .image-mask:hover{
      opacity: 0.3;
      background: rgba(0,0,0,0);
      // width: 180px;
      // height: 100px;
      border-radius: 4px; 
    }
    .imgSty{
      position: absolute;
      right: 6px;
      bottom: 6px;
    }
.exercises-body{
  position: relative;
}
.exercises-left{
  background-color: #ffffff;
  width: 100%;
  box-sizing: border-box;
  // margin-right: 20px;
  overflow-y: auto;
  overflow-x: hidden;
}
/* 答题卡 */
.exercises-right{
  width: 252px;
  height: 382px;
  background: #ffffff;
  position: absolute;
  right: -260px;
  top: 0;
  box-sizing: border-box;
  padding: 24px 22px 30px 26px;
}
.exercises-right h4{
  font-size: 18px;
  line-height: 24px;
  color: #202020;
  font-weight: bolder;
  text-align: center;
  margin-bottom: 20px;
}
.exercises-right .exercises-card{
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  max-height: 230px;
}
.exercises-right .exercises-card-item{
  width: 30px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid #DDDDDD;
  color: #979CA1;
  background: #FEFFFE;
  line-height: 30px;
  text-align: center;
  margin-right: 8px;
  margin-bottom: 10px;
  cursor: pointer;
}
.exercises-right .exercises-card-item:nth-child(5n){
  margin-right: 0;
}
.exercises-right .exercises-card .active-true{
  background: #D1F1E6;
  color: #0BB65D;
  border: none;
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.exercises-right .exercises-card .active-false{
  background: #FDDAD1;
  color: #F34718;
  border: none;
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.exercises-right .exercises-card .active-cur{
  color: #26BE6F;
  border: 1px solid #0BB65D;
}
.exercises-right button{
  width: 92px;
  height: 34px;
  color: #FFFFFF;
  text-align: center;
  line-height: 34px;
  background: linear-gradient(315deg, #ED3F10, #FB724D);
  border-radius: 17px;
  cursor: pointer;
  border: none;
  margin: 0 auto;
  display: block;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}
/* 滚动条样式 */
.exercises-card::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.exercises-card::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
.exercises-card::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.exercise-body-top{
  display: flex;
  padding-bottom: 9px;
  border-bottom: 1px solid #EFEFEF;
}
.exercise-body-top .mode{
  margin-right: 30px;
  color: #202020;
  line-height: 20px;
}
.exercise-body-top .mode:first-child{
  font-weight: 700;
  font-size: 16px;
  position: relative;
}
.exercise-body-top .mode:last-child{
  font-size: 14px;
}
.exercise-body-top .mode i{
  position: absolute;
  bottom: -8px;
  width: 64px;
  height: 4px;
  border-radius: 2px;
  background: linear-gradient(315deg,#ED3F10,#FB724D);
}
.exercise-body-top .feedback{
  margin-left: auto;
}
.exercise-body-top  img{
  width: 20px;
  height: 20px;
  vertical-align: bottom;
}
.exercise-body-top .feedback{
  margin-right: 20px;
  cursor: pointer;

}
.exercise-body-top .collect{
  cursor: pointer;
}
.exercise-TF{
  // width: 490px !important;
  width: 560px !important;
  box-sizing: border-box;
  padding: 0 20px 24px 36px;
  .exercise_tmbt {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-500;
    font-weight: 500;
    color: #202020;
    margin-top: 24px;
    margin-bottom: 8px;
    white-space: pre-wrap;
    overflow: auto;
    max-height: 140px;
  }
  .exercise_duosht {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-500;
    font-weight: 500;
    color: #848586;
    margin-top: 24px;
  }
  .exercise_jdpd {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    margin-top: 24px;
    color: #202020;
    .exercise_timf {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #848586;
    }
  }
}
.exercise-TF h3{
  font-size: 24px;
  line-height: 22px;
  color: #202020;
  font-weight: bolder;
  text-align: center;
  padding: 30px 0;
}
// .exercise-TF p{
//   font-size: 16px;
//   font-weight: 400;
//   color: #202020;
//   line-height: 28px;
// }
// .exercise-TF p span{
  
// }
::v-deep .el-radio__inner {
    border-radius: 50%;
    width: 18px;
    height: 18px;
  }

  // ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
  //   content: "";
  //   width: 10px;
  //   height: 5px;
  //   border: 1px solid white;
  //   border-top: transparent;
  //   border-right: transparent;
  //   text-align: center;
  //   display: block;
  //   position: absolute;
  //   top: 3px;
  //   left: 2px;
  //   vertical-align: middle;
  //   transform: rotate(-45deg);
  //   border-radius: 0px;
  //   background: none;
  // }
  ::v-deep .el-radio__input.is-checked.is-disabled .el-radio__inner::after {
    content: "";
    width: 10px;
    height: 5px;
    border: 1px solid #888888;
    border-top: transparent;
    border-right: transparent;
    text-align: center;
    display: block;
    position: absolute;
    top: 3px;
    left: 2px;
    vertical-align: middle;
    transform: rotate(-45deg);
    border-radius: 0px;
    background: none;
  }
  ::v-deep .el-checkbox__inner{
    border-radius: 50%;
    width: 18px;
    height: 18px;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after {
    content: "";
    width: 10px;
    height: 5px;
    border: 1px solid white;
    border-top: transparent;
    border-right: transparent;
    text-align: center;
    display: block;
    position: absolute;
    top: 3px;
    left: 2px;
    vertical-align: middle;
    transform: rotate(-45deg);
    border-radius: 0px;
    background: none;
  }
/* 判断题 */
.exercise-TF .TF-selection{
  display: flex;
  flex-direction: column;
  padding-right: 12px;
  box-sizing: border-box;
}
.TF-selection{
  

  .selection_duanx {
    margin-top: 8px;
    ::v-deep .el-radio__input.is-disabled + span.el-radio__label {
      position: relative;
      top: 4px;
    }
    ::deep .el-radio__input.is-checked .el-radio__inner::after {
      top: 8px;
      left: 8px;
      width: 4px;
      height: 4px;
      background: #ffffff;
      border: 2px solid #e3e8e9;
      border-radius: 9px;
    }
    ::v-deep .el-radio.is-bordered { 
      padding: 15px 20px 9px 10px;
    }
    ::v-deep .el-radio.is-bordered.is-checked {
      width: 488px;
      height: 52px;
      background: #EAF1FF;
      border: 1px solid #EAF1FF;
      border-radius: 8px;
    }
    ::v-deep .el-radio.is-bordered {
      width: 488px;
      height: 52px;
      border: 1px solid #f0f4f5;
      border-radius: 8px;
    }
    ::v-deep .el-checkbox.is-bordered { 
      padding: 15px 20px 9px 10px;
      display: flex;
      align-items: center;
    }
    ::v-deep .el-checkbox.is-bordered.is-checked {
      width: 488px;
      height: fit-content;
      background: #EAF1FF;
      border: 1px solid #EAF1FF;
      border-radius: 8px;
    }
    ::v-deep .el-checkbox:last-of-type {
      width: 488px;
      height: fit-content;
      border: 1px solid #EAF1FF;
      border-radius: 8px;
    }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after {
      top: 4px;
      left: 4px;
      width: 4px;
      height: 4px;
      background: #ffffff;
      border: 2px solid #e3e8e9;
      border-radius: 9px;
    }
  }
  .selection_duanxyi {
    margin-top: 8px;
    ::v-deep .el-checkbox.is-bordered { 
      padding: 15px 20px 9px 10px;
    }
    ::v-deep .el-checkbox.is-bordered {
      width: 488px;
      height: fit-content;
      background: #e8f8f3;
      border: 1px solid #10b881;
      border-radius: 8px;
    }
    // ::v-deep .el-checkbox:last-of-type {
    //   width: 488px;
    //   height: fit-content;
    //   border: 1px solid #f0f4f5;
    //   border-radius: 8px;
    // }
    ::v-deep .el-checkbox__input .el-checkbox__inner::after {
      top: 4px;
      left: 4px;
      width: 4px;
      height: 4px;
      background: #ffffff;
      border: 2px solid #e3e8e9;
      border-radius: 9px;
    }
    ::v-deep .el-checkbox__input + .el-checkbox__label {
      color: #202020;
    }
    ::v-deep .el-checkbox.is-bordered.is-checked {
      width: 488px;
      height: fit-content;
      background: #e8f8f3;
      border: 1px solid #10b881;
      border-radius: 8px;
    }
    // ::v-deep .el-checkbox:last-of-type {
    //   width: 488px;
    //   height: fit-content;
    //   border: 1px solid #f0f4f5;
    //   border-radius: 8px;
    // }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after {
      top: 4px;
      left: 4px;
      width: 4px;
      height: 4px;
      background: #ffffff;
      border: 2px solid #e3e8e9;
      border-radius: 9px;
    }
    ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #202020;
    }
  }
  .selection_duanxer {
    margin-top: 8px;
    width: 100%;
    height: fit-content;
    ::v-deep .el-checkbox.is-bordered { 
      padding: 15px 20px 9px 10px;
    }
    ::v-deep .el-checkbox.is-bordered.is-checked {
      width: 488px;
      height: fit-content;
      background: rgba(255,137,130,0.10);
      border: 1px solid #ff8982;
      border-radius: 8px;
    }
    ::v-deep .el-checkbox:last-of-type {
      width: 488px;
      height: fit-content;
      border: 1px solid #f0f4f5;
      border-radius: 8px;
    }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after {
      top: 4px;
      left: 4px;
      width: 4px;
      height: 4px;
      background: #ffffff;
      border: 2px solid #e3e8e9;
      border-radius: 9px;
    }
    ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #202020;
    }
  }
  .selection_danxtyi {
    width: 100%;
    min-height: 52px;
    background: #EAF1FF;
    border: 1px solid #EAF1FF;
    border-radius: 8px;
    // line-height: 52px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    color: #202020;
    margin-top: 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .selection-item {
      margin-left: 16px;
      margin-right: 8px;      
    }
  }
  .selection_danxt {
    width: 100%;
    min-height: 52px;
    box-sizing: border-box;
    border: 1px solid #E3E8E9;
    border-radius: 8px;
    // line-height: 52px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    box-sizing:border-box;
    color: #202020;
    margin-top: 8px;
    display: flex;
    align-items: center;
    .selection-item {
      margin-left: 16px;
      margin-right: 8px;
    }
  }

  .selection_danxtsan {
    width: 100%;
    min-height: 52px;
    background: #e8f8f3;
    border: 1px solid #10b881;
    border-radius: 8px;
    // line-height: 52px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    box-sizing: border-box;
    color: #202020;
    margin-top: 8px;
    display: flex;
    align-items: center;
    .selection-item {
      margin-left: 16px;
      margin-right: 8px;
    }
  }
  .selection_danxter {
    width: 100%;
    // height: 52px;
    background: rgba(255,137,130,0.10);
    border: 1px solid #ff8982;
    border-radius: 8px;
    // line-height: 52px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    color: #202020;
    margin-top: 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .selection-item {
      margin-left: 16px;
      margin-right: 8px;
    }
  }
  .selection_duanxpde {
    margin-top: 8px;
    ::v-deep .el-radio__input.is-disabled + span.el-radio__label {
      position: relative;
      top: 4px;
    }
    ::v-deep .el-radio__input {
      top: 4px;
      left: 4px;
    }
    ::v-deep .el-checkbox.is-bordered { 
      padding: 15px 20px 9px 10px;
    }
    ::v-deep .el-radio.is-bordered.is-disabled {
      width: 488px;
      height: 52px;
      background: #e8f8f3;
      border: 1px solid #10b881;
      border-radius: 8px;
    }
    ::v-deep .el-checkbox:last-of-type {
      width: 488px;
      height: 52px;
      border: 1px solid #f0f4f5;
      border-radius: 8px;
    }
    ::v-deep .el-radio__input.is-checked.is-disabled .el-radio__inner::after {
      top: 4px;
      left: 4px;
      width: 4px;
      height: 4px;
      background: #ffffff;
      border: 2px solid #e3e8e9;
      border-radius: 9px;
    }
    ::v-deep .el-radio__input.is-disabled + span.el-radio__label {
      color: #202020;
    }
  }
  .selection_duanxpdy {
    margin-top: 8px;
    ::v-deep .el-radio__input.is-disabled + span.el-radio__label {
      position: relative;
      top: 4px;
    }
    ::v-deep .el-radio__input {
      top: 4px;
      // left: 4px;
    }
    ::v-deep .el-checkbox.is-bordered { 
      padding: 15px 20px 9px 10px;
    }
    ::v-deep .el-radio.is-bordered.is-disabled {
      width: 488px;
      height: 52px;
      background: rgba(255,137,130,0.10);
      border: 1px solid #ff8982;
      border-radius: 8px;
    }
    ::v-deep .el-checkbox:last-of-type {
      width: 488px;
      height: 52px;
      border: 1px solid #f0f4f5;
      border-radius: 8px;
    }
    ::v-deep .el-radio__input.is-checked.is-disabled .el-radio__inner::after {
      top: 4px;
      left: 4px;
      width: 4px;
      height: 4px;
      background: #ffffff;
      border: 2px solid #e3e8e9;
      border-radius: 9px;
    }
    ::v-deep .el-radio__input.is-disabled + span.el-radio__label {
      color: #202020;
    }
  }

}
.exercise-TF .TF-selection .selection-item{
  // font-size: 16px;
  // color: #888888;
  // line-height: 28px;
  // margin-right: 12px;
}
.exercise-TF .TF-selection .selection-content{
  padding: 10px 5px;
  // font-size: 16px;
  // color: #202020;
  // line-height: 28px;
  // // display: inline-block;
  // // width: 750px;
  // white-space:pre-wrap;
  // vertical-align: top
}
.selection_duanxpde .selection-content {
  padding: 10px 0px;
  color: #202020;
}
.exercise-TF .el-radio{
  align-items: center ;
}
.signal-choose{
    margin-bottom: 20px;
}
.exercise-TF .el-radio__inner{
  width: 18px;
  height: 18px;
}
/* 单选题 */
.TF-selection .el-radio-group{
  display: flex;
  flex-direction: column;
}
.TF-selection .el-radio__inner::after{
  box-sizing: content-box;
  content: "";
  border: 1px solid #ffffff;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 6px;
  position: absolute;
  top: 3px;
  width: 3px !important;
  border-radius: 0;
  background: transparent !important;
  transform: rotate(45deg) scaleY(1) !important;
  transform-origin:center !important;
}
/* 多选题 */
.TF-selection .el-checkbox-group{
  display: flex;
  flex-direction: column;
}
/* 多选题 */
// .TF-selection .el-checkbox-group .el-checkbox{
//   margin-bottom: 20px;
// }
::v-deep .TF-selection .el-textarea__inner:focus {
  border: 1px solid #286bff !important;
  background: #fff !important;
}

::v-deep .TF-selection .el-textarea__inner::placeholder{
  color: #666666;
  font-family: PingFang SC, PingFang SC-400;
}
/* 滚动条样式 */
::v-deep .TF-selection .el-textarea__inner::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::v-deep .TF-selection .el-textarea__inner::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #E3E8E9;
}
::v-deep .TF-selection .el-textarea__inner::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #E3E8E9;
}
/* 简答题 */
.TF-selection .el-textarea__inner{
  background: #F7F7F7;
  resize:none;
  height: 180px;
  padding-left: 50px;
}
.TF-selection .brief-input-box{
  position: relative;
  ::v-deep .el-textarea__inner{
    font-size: 14px;
    width: 488px;
    height: 200px;
    background: #f4f6f6;
    border: 1px solid #f0f4f5;
    border-radius: 8px;
    color: #202020;
    font-family: PingFang SC, PingFang SC-400;
  }
}
.attachment-list{
  max-height: 128px;
  overflow-y: scroll;
  margin-top: 10px;
  .attachment-itemyi{
    width: 440px;
    // height: 64px;
    background: #EFF2F5;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 5px 16px 5px 6px;
    margin-bottom: 10px;
    border-radius: 4px;
    cursor: pointer;
    .attachment-name{
      max-width: 280px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      font-size: 14px;
    }
    .file-icon{
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .upload-status{
      .progress{
        display: flex;
        align-items: center;
        ::v-deep .el-progress-bar__outer{
          background-color:#ffffff;
        }
        span{
          font-size: 12px;
          color: #888888;
        }
      }
    }
    .upload-status.teacher{
      display: flex;
      align-items: center;
      width: 100%;
      .progress{
        margin-top: 0;
       margin-left: auto;
      }
    }
    .close-icon{
      width: 16px;
      height: 16px;
      margin-left: auto;
      cursor: pointer;
    }
  }
  .attachment-item{
    // height: 64px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 5px 16px 5px 6px;
    margin-bottom: 10px;
    width: 484px;
    height: 32px;
    background: #f4f6f6;
    border-radius: 8px;
    cursor: pointer;
    .attachment-name{
      max-width: 280px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      font-size: 14px;
    }
    .file-icon{
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .upload-status{
      .progress{
        display: flex;
        align-items: center;
        ::v-deep .el-progress-bar__outer{
          background-color:#ffffff;
        }
        span{
          font-size: 12px;
          color: #888888;
        }
      }
    }
    .upload-status.teacher{
      display: flex;
      align-items: center;
      width: 100%;
      .progress{
        margin-top: 0;
       margin-left: auto;
      }
    }
    .close-icon{
      width: 16px;
      height: 16px;
      margin-left: auto;
      cursor: pointer;
    }
  }
}
.add-attachment{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  color: #666666;
  cursor: pointer;
  display: flex;
  img{
    width: 16px;
    height: 16px;
    margin-right: 4px;
    margin-top: 2px;
  }
}
.TF-selection .brief-input-box .answer-text{
  position: absolute;
  top: 6px;
  left: 13px;
  color: #c0c4cc;
}
.switch-question{
  width: 488px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #6B6B6B;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 18px;
}
.switch-question img{
  width: 14px;
  height: 14px;
  vertical-align: middle;
  transform: translateY(-1px);
}
.switch-question .switch-prev-question {
  width: 32px;
  height: 32px;
  background: #eaf1ff;
  border-radius: 8px;
  margin-right: 8px;
  img {
    width: 20px;
    height: 20px;
  }
}
.switch-question {
  .switch-next-question-tj {
    width: 304px;
    height: 32px;
    background: #286bff;
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    line-height: 32px;
    cursor: pointer;
  }
  .switch-next-question {
    width: 32px;
    height: 32px;
    background: #286bff;
    border-radius: 8px;
    margin-left: 8px;
    img {
      width: 20px;
      height: 20px;
    }
  }
} 
.switch-question .switch-prev-question, .switch-question .switch-next-question{
  cursor: pointer;
}
.submit-question{
  display: flex;
  margin-left: auto;
  align-items: center;
}
.submit-question div{
  color: #202020;
  margin-right: 10px;
}
.submit-question div span:first-child{
  color: #F34718;
}
.switch-next-question{
  width: 92px;
  height: 32px;
  color: #FFFFFF;
  text-align: center;
  line-height: 32px;
  background: #1872ed;
  border-radius: 17px;
  cursor: pointer;
  margin-left: auto;
}
.zuoduiqies {
  margin-left: 187px;
}
.switch-prev-questioner{
  width: 120px;
  height: 32px;
  color: #ffffff;
  border-radius: 8px;
  text-align: center;
  line-height: 32px;
  background: #286bff;
  // border-radius: 17px;
  cursor: pointer;
  // margin-left: auto;
}
.switch-prev-questionsan{
  width: 120px;
  height: 32px;
  color: #9a9c9f;
  border-radius: 8px;
  text-align: center;
  line-height: 32px;
  background: #f4f6f6;
  // border-radius: 17px;
  cursor: pointer;
  // margin-left: auto;
}
.switch-prev-questionyi{
  width: 120px;
  height: 32px;
  color: #202020;
  border-radius: 8px;
  text-align: center;
  line-height: 32px;
  background: #ebeef4;
  // border-radius: 17px;
  cursor: pointer;
  // margin-left: auto;
}
.switch-prev-question{
  width: 92px;
  height: 32px;
  color: #202020;
  text-align: center;
  line-height: 32px;
  background: #EFF2F5;
  border-radius: 17px;
  cursor: pointer;
}
.exercises_answer {
  .exercises_tmjx {
    width: 488px;
    margin: 0 auto;
    .exercises_tmjxnr {
      width: 488px;
      height: 80px;
      // background: #848586;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #848586;
      overflow-y: auto;
      margin-top: 8px;
    }
    .exercises_tmjxbt {
      width: 488px;
      height: 22px;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #202020;
    }
  }
  .exercises_daanhz {
    width: 488px;
    height: 38px;
    line-height: 38px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    .exercises_zqdat img {
      width: 22px;
      height: 16px;
      margin-top: 11px;
    }
    .exercises_zqdat {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-600;
      font-weight: 600;
      color: #202020;
    }
  }
}
.mask{
  position: fixed;
  left: 0;
  top:0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2001;
}
.submit-layout{
  width: 360px;
  height: 420px;
  background-color: #ffffff;
  border-radius: 16px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 11;
  box-sizing: border-box;
  padding: 60px 0 50px 0;
  z-index: 2002;
  display: flex;
  flex-direction: column;
  align-items: center;
  img{
    width: 64px;
    height: 64px;
    margin-bottom: 29px;
  }
  .title{
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #000000;
  }
  .sub-title{
    font-size: 14px;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 19px;
    color: #888888;
  }
  .score{
    font-size: 36px;
    font-weight: 600;
    color: #000000;
    span{
      font-size: 14px;
      font-weight: 400;
      font-size: 14px;
      color: #888888;
    }
  
  }
  .tips{
    color: #F34718;
    font-size: 14px;
    margin-bottom: 12px;
  }
  .feedback-btn{
    button{
      width: 210px;
      height: 40px;
      background: linear-gradient(131deg,#73aaff 3%, #0053ff 90%);
      border-radius: 22px;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      line-height: 40px;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }
}
.submit-layout .title{
  font-size: 18px;
  line-height: 26px;
  font-weight: bold;
  color: #101010;
}
.submit-layout .feedback-btn button{
  font-size: 14px;
}
::v-deep .TFquestion .el-radio__input {
  display: none !important;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{
  border-color: #1872ed !important;
  background: #286BFF !important;
}
</style>